import React from "react";
import TermList from "../components/TermList";

const Dictionary = () => {
  return (
    <main>
      <TermList />
    </main>
  );
};

export default Dictionary;
